import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import {
  Grid,
  Paper,
  Typography,
  Tabs,
  Tab,
  Box,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Container
} from '@mui/material';
import {
  BurndownChart,
  VelocityChart, 
  IssueDistributionChart,
  SprintProgress,
  ResourceUtilizationChart,
} from './PMMainReport';
// Add these at the top of your file
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Document, Packer, Paragraph, TextRun, ImageRun } from 'docx';

import { saveAs } from 'file-saver';

import axios from 'axios';
import { Description, PictureAsPdf } from '@mui/icons-material';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    maxWidth: '100%',
    overflow: 'hidden',
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  chartContainer: {
    width: '100%',
    minHeight: 400,
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  tabPanel: {
    width: '100%',
    padding: 0,
  },
  distributionGrid: {
    width: '100%',
    margin: 0,
  },
  // Add PDF export styles
  pdfExportMode: {
    '& table': {
      width: '100% !important',
      tableLayout: 'auto !important',
      minWidth: '100% !important',
      maxWidth: '100% !important',
      margin: '0 !important',
      borderCollapse: 'collapse !important',
    },
    '& table th, & table td': {
      padding: '8px 12px !important',
      whiteSpace: 'normal !important',
      overflow: 'visible !important',
      wordWrap: 'break-word !important',
      fontSize: '12px !important',
    },
    '& table th': {
      backgroundColor: '#1976d2 !important',
      color: 'white !important',
    },
    '& .MuiTableContainer-root': {
      maxHeight: 'none !important',
      overflow: 'visible !important',
    },
    '& .recharts-wrapper': {
      width: '100% !important',
      height: 'auto !important',
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export default function ReportsDashboard() {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);

  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [sprints, setSprints] = useState([]);
  const [selectedSprint, setSelectedSprint] = useState('');
  const [reportData, setReportData] = useState({});
  const [error, setError] = useState(null);

       const [employeeId, setEmployeeId] = useState(null);


      const getEmployeeid = async () => {
      try {
         const token = localStorage.getItem('token');
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
    
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;
        const response = await axios.get(`${API_URL}/api/user/current?company_id=${company_id}`, {
          withCredentials: true
        });
  
        if (!response.data || !response.data.employee_id) {
          alert('Session Expired, Please login again')
          throw new Error('Employee ID not found in user data');
        }
  
        setEmployeeId(response.data.employee_id);
        
        return response.data.employee_id;
      } catch (err) {
        //console.error("Error fetching current user:", err);
        setError('Failed to fetch user information');
        return null;
      }
    };
  // Fetch all projects on load
  useEffect(() => {
    const fetchProjects = async () => {
      try {
          const token = localStorage.getItem("token"); // get JWT token
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
        const employee_id= await getEmployeeid();

        const res = await axios.get(`${API_URL}/api/projects/project-manager-project-management?employee_id=${employee_id}`,
           {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
        );
        setProjects(res.data.data);
        if (res.data.length > 0) setSelectedProjectId(res.data[0].project_id);
      } catch (err) {
        //console.error('Error fetching projects:', err);
      }
    };
    fetchProjects();
  }, []);

  // Fetch sprints when project changes
  useEffect(() => {
      const token = localStorage.getItem("token"); // get JWT token
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
    const fetchSprints = async () => {
      if (!selectedProjectId) return;
      try {
        const response = await axios.get(`${API_URL}/api/reports/projects/${selectedProjectId}/sprints`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        setSprints(response.data);
        if (response.data.length > 0) setSelectedSprint(response.data[0].id);
      } catch (error) {
        //console.error('Error fetching sprints:', error);
      }
    };
    fetchSprints();
  }, [selectedProjectId]);

const handleExportPDF = async () => {   
  if (!selectedProjectId) {
    alert("Please select a project first.");
    return;
  }
  try {     
    const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
    
    const response = await axios.get(`${API_URL}/api/reports/export/pdf/${selectedProjectId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      responseType: 'blob'
    });
    
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Project-Report-${selectedProjectId}-${new Date().toISOString().split('T')[0]}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {     
    //console.error('PDF export failed:', error);   
    alert('Failed to export PDF: ' + (error.response?.data?.error || error.message));
  } 
};

const handleExportWord = async () => {
  if (!selectedProjectId) {
    alert("Please select a project first.");
    return;
  }
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
    
    const response = await axios.get(`${API_URL}/api/reports/export/doc/${selectedProjectId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      responseType: 'blob'
    });
    
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Project-Report-${selectedProjectId}-${new Date().toISOString().split('T')[0]}.docx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (err) {
    //console.error("Word export failed:", err);
    alert('Failed to export Word: ' + (err.response?.data?.error || err.message));
  }
};





  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleProjectChange = (event) => {
    setSelectedProjectId(event.target.value);
    setReportData({});
    setSprints([]);
    setSelectedSprint('');
  };

  const handleSprintChange = (event) => {
    setSelectedSprint(event.target.value);
  };

  const fetchReportData = async (reportType) => {
      const token = localStorage.getItem("token"); // get JWT token
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
    setLoading(true);
    try {
      let response;
      switch (reportType) {
        case 'burndown':
          response = await axios.get(`${API_URL}/api/reports/burndown/${selectedSprint}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });
          // 
          break;
        case 'velocity':
          response = await axios.get(`${API_URL}/api/reports/velocity/${selectedProjectId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });
          
          break;
        case 'distribution':
          response = await axios.get(`${API_URL}/api/reports/distribution/${selectedProjectId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });
          // 
          break;
        case 'project-completion':
          response = await axios.get(`${API_URL}/api/reports/project-completion/${selectedProjectId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });
          break;
        case 'sprint-progress':
          response = await axios.get(`${API_URL}/api/reports/sprint-progress/${selectedSprint}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });
          
          break;
        case 'resource-utilization':
          response = await axios.get(`${API_URL}/api/reports/resource-utilization/${selectedProjectId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });
          // 
          break;
        default:
          break;
      }
      setReportData(prev => ({ ...prev, [reportType]: response.data }));

    } catch (error) {
      //console.error(`Error fetching ${reportType} report:`, error);
    } finally {
      setLoading(false);
    }
  };

  // Load report when tab or sprint changes
  useEffect(() => {
    if (!selectedSprint) return;

    if (tabValue === 0) fetchReportData('burndown');
    if (tabValue === 2) fetchReportData('sprint-progress');
  }, [selectedSprint, tabValue]);

  useEffect(() => {
    if (tabValue === 1) fetchReportData('velocity');
    // if (tabValue === 2) fetchReportData('distribution');
    if (tabValue === 3) fetchReportData('resource-utilization'); 
    // if (tabValue === 3) fetchReportData('project-completion');
  }, [tabValue, selectedProjectId]);

  return (
    <div className={classes.root}>
     <Container
  maxWidth={false}
  sx={{
    mt: 2,
    paddingTop: 4,
    mb: 4,
    width: '100%',
    border: "2px solid",
    borderColor: "grey.300",
    boxShadow: 4
  }}
>
        <Box display="flex" justifyContent="space-between" mb={2} gap={2}>
  <Box>
     <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', }}>
          Project Management Reports
        </Typography>
  </Box>
  <Box display="flex" gap={2} alignItems="center">
 <Button variant="outlined" color="primary" 
  onClick={handleExportPDF}
  startIcon={<PictureAsPdf/>}
  sx={{
       padding: "10px 16px",
      fontSize: "0.9rem",
     textTransform: "none",
    borderRadius: "8px",
    borderWidth: 2,
    borderColor: "primary",
     color: "primary",
     "&:hover": {
      borderColor: "#1d4ed8",
      bgcolor: "#eff6ff",
      },
  }}
  >
    Export as PDF
  </Button>
  <Button variant="outlined" color="primary"
   onClick={handleExportWord}
   startIcon={<Description/>}
   sx={{
                padding: "10px 16px",
                fontSize: "0.9rem",
                textTransform: "none",
                borderRadius: "8px",
                borderWidth: 2,
                borderColor: "primary",
                color: "primary",
                "&:hover": {
                  borderColor: "#1d4ed8",
                  bgcolor: "#eff6ff",
                },
              }}
   >
    Export as Word
  </Button>
  </Box>
 
</Box>

<FormControl variant="outlined" sx={{width:'300px'}}>
  <InputLabel id="project-label">Select Project</InputLabel>

  <Select
    labelId="project-label"
    id="project-select"
    value={selectedProjectId}
    onChange={handleProjectChange}
    label="Select Project"
  >
    {projects.map((project) => (
      <MenuItem key={project.project_id} value={project.project_id}>
        {project.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>
        {/* Sprint Dropdown */}
        {(tabValue === 0 || tabValue === 2) && (
         <FormControl variant="outlined" sx={{width:'300px',ml:3}}>
         <InputLabel id="sprint-label">Select Sprint</InputLabel>
       
         <Select
           labelId="sprint-label"
           label="Select Sprint"
           value={selectedSprint}
           onChange={handleSprintChange}
         >
           {sprints.map((sprint) => (
             <MenuItem key={sprint.id} value={sprint.id}>
               {sprint.name} ({new Date(sprint.startDate).toLocaleDateString()} -{" "}
               {new Date(sprint.endDate).toLocaleDateString()})
             </MenuItem>
           ))}
         </Select>
       </FormControl>
        )}





        {/* Tabs */}
             <Tabs 
          value={tabValue} 
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab label="Burndown Chart" />
          <Tab label="Velocity Report" />
          {/* <Tab label="Issue Distribution" /> */}
          {/* <Tab label="Project Completion" /> */}
          <Tab label="Sprint Progress" />
          <Tab label="Resource Utilization" />
        </Tabs>


        {/* Loader */}
        {loading && (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        )}

        {/* Tab Panels */}

        <div id="report-content">
        <TabPanel value={tabValue} index={0}>
          <div className={classes.chartContainer}>
            {reportData.burndown && <BurndownChart data={reportData.burndown} />}
          </div>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <div className={classes.chartContainer}>
            {reportData.velocity && <VelocityChart data={reportData.velocity} />}
          </div>
        </TabPanel>

        <TabPanel value={tabValue} >
          <Grid container spacing={3}>
            {/* <Grid item xs={12} md={6}>
              <Paper className={classes.paper}>
                <Typography variant="h6">By Status</Typography>
                <div className={classes.chartContainer}>
                  {reportData.distribution?.statusDistribution && (
                    <IssueDistributionChart data={reportData.distribution.statusDistribution} type="status" />
                  )}
                </div>
              </Paper>
            </Grid> */}
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                {/* <Typography variant="h6">By Type</Typography> */}
                <div className={classes.chartContainer}>
                  {reportData.distribution?.typeDistribution && (
                    <IssueDistributionChart data={reportData.distribution.typeDistribution} type="type" />
                  )}
                </div>
              </Paper>
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <div className={classes.chartContainer}>
            {reportData['sprint-progress'] && <SprintProgress data={reportData['sprint-progress']} />}
          </div>
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
  <div className={classes.chartContainer}>
    {reportData['resource-utilization'] && (
<ResourceUtilizationChart data={reportData['resource-utilization']?.utilization || []} />
    )}
  </div>
</TabPanel>
</div>
      </Container>
    </div>
  );
}